import { useAuth } from '../contexts/AuthContext';
import NotificationCard from '../components/NotificationCard';

// Port aus routes/profil/+page.svelte.

const ROLLE: Record<string, string> = { admin: 'Administrator', arzt: 'Arzt/Ärztin', mpa: 'MPA', pflege: 'Pflege', user: 'Benutzer' };
const MODUS: Record<string, string> = { patient: 'Patientenakte', patient_md: 'Patientenakte (Markdown)', praxis: 'Alle Akten', wissen: 'Medizinisches Nachschlagen', general: 'Allgemein' };

export default function Profil() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="space-y-4">
      <section className="card">
        <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
          <h1 className="page-h1">Profil</h1>
          <span className="badge badge-brand">{ROLLE[user.role] ?? user.role}</span>
        </div>
        <dl className="grid gap-x-4 gap-y-2 text-sm sm:grid-cols-[140px_1fr]">
          <dt className="text-ps-dark-400">Voller Name</dt><dd className="text-ps-dark-900">{user.name}</dd>
          <dt className="text-ps-dark-400">Benutzername</dt><dd className="font-mono text-ps-dark-900">{user.username ?? '—'}</dd>
          <dt className="text-ps-dark-400">E-Mail</dt><dd className="text-ps-dark-700">{user.email}</dd>
          <dt className="text-ps-dark-400">Rolle</dt><dd className="text-ps-dark-700">{ROLLE[user.role] ?? user.role}</dd>
          <dt className="text-ps-dark-400">Erlaubte Bereiche</dt>
          <dd className="flex flex-wrap gap-1.5">{user.allowed_modes.map((m) => <span key={m} className="badge badge-neutral">{MODUS[m] ?? m}</span>)}</dd>
          {user.last_login_at && (<>
            <dt className="text-ps-dark-400">Letzter Login</dt>
            <dd className="numerical text-xs text-ps-dark-500">{new Date(user.last_login_at).toLocaleString('de-CH', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</dd>
          </>)}
        </dl>
        <p className="mt-3 border-t border-gray-200 pt-3 text-xs leading-relaxed text-ps-dark-400">
          Name, E-Mail oder Rolle ändern? Sprich Christian (Admin) an — die Daten werden zentral in der Verwaltung gepflegt. Das Passwort gehört zum PowerID-Konto und wird dort geändert, nicht hier.
        </p>
      </section>


      <NotificationCard />
    </div>
  );
}
